import { formatData } from '@/utils/util'
import moment from 'moment'

// 账单月份
export const BILL_MONTH = {
  1: '1月',
  2: '2月',
  3: '3月',
  4: '4月',
  5: '5月',
  6: '6月',
  7: '7月',
  8: '8月',
  9: '9月',
  10: '10月',
  11: '11月',
  12: '12月',
}
export const BILL_MONTH_C0MP = {
  '01': '1月',
  '02': '2月',
  '03': '3月',
  '04': '4月',
  '05': '5月',
  '06': '6月',
  '07': '7月',
  '08': '8月',
  '09': '9月',
  '10': '10月',
  '11': '11月',
  '12': '12月',
}
// 开票状态
// export const STATUS_MAP = {
//   WAIT_CONFIRM: '待确认',
//   NONE_INVOICE: '待开票',
//   PART_INVOICE: '部分开票',
//   NO_INVOICE: '不开票',
//   NOT_VERIFY: '待审核',
//   ALREADY_INVOICE: '已开票'
// }
export const receivableInvoiceStatusTxt = {
  HAVENO_INVOICE: '待发起开票申请',
  APPLIED_INVOICE: '已申请开票',
  NO_INVOICE: '不开票',
  NOT_INVOICE: '待开票',
  PART_INVOICE: '部分开票',
  INVOICE: '已开票',
  APPLY_OA_INVOICE: '申请OA开票中',
  NOT_VERIFY: '待审核',
  PAY_REVIEW: '待支付审核',
  DISCOUNT_W: '待折扣确认',
  MAILED: '已邮寄',
  CANCEL_OA: 'OA审批拒绝/取消',
};
// 账单状态
// export const BILL_STATUS = {
//   PENDING: '待对账',
//   CONFIRMED: '已对账',
//   CONFIRM_BILL: '确认开票',
//   REJECTED_BILL: '撤销开票',
//   REJECTED: '驳回'
// }
export const BILL_STATUS = {
  BILL_PENDING: 'BILL_PENDING',
  BILL_BACK: 'BILL_BACK',
  BILL_HAVE_CHECK: 'BILL_HAVE_CHECK',
  BILL_RECONCILIATION: 'BILL_RECONCILIATION',
}
export const BILL_STATUS_TEXT = {
  BILL_PENDING: '待发送',
  BILL_BACK: '已退回',
  BILL_HAVE_CHECK: '已对账',
  BILL_RECONCILIATION: '对账中',
}
export const BILL_STATUS_TEXT_COLOR = {
  BILL_PENDING: '#FF7D00',
  BILL_BACK: '#F53F3F',
  BILL_HAVE_CHECK: '#00B42A',
  BILL_RECONCILIATION: '#1677FF',
}
// 账单列表页table配置
export const tableColumns = [
  {
    title: '账单批次号',
    dataIndex: 'billCode',
    key: 'billCode',
    scopedSlots: { customRender: "billCode" },
    width: 200,
    fixed: true,
  },
  {
    title: '账单名称',
    dataIndex: 'billName',
    key: 'billName',
    width: 190,
    scopedSlots: { customRender: "billName" },
  },
  {
    title: '账单状态',
    dataIndex: 'billStatus',
    key: 'billStatus',
    width: 100,
    scopedSlots: { customRender: "billStatus" },
  },
  // {
  //   title: '外部客户名称',
  //   dataIndex: 'outCustomerName',
  //   key: 'outCustomerName',
  //   width: 160,
  //   scopedSlots: { customRender: "outCustomerName" },
  // },
  {
    title: '服务方名称',
    dataIndex: 'payee',
    key: 'payee',
    width: 180,
    ellipsis: true,
  },
  {
    title: '服务方主体',
    dataIndex: 'payeeInfo',
    key: 'payeeInfo',
    width: 300,
    ellipsis: true,
  },
  {
    title: '账期月份',
    dataIndex: 'accountMonth',
    key: 'accountMonth',
    width: 100,
    scopedSlots: { customRender: "accountMonth" },
    ellipsis: true,
  },
  {
    title: '账单总金额',
    dataIndex: 'billMoneyTaxFormat',
    key: 'billMoneyTaxFormat',
    customRender: (text) => text || '--',
    width: 200,
    ellipsis: true,
  },
  {
    title: '开票状态',
    dataIndex: 'invoiceStatus',
    key: 'invoiceStatus',
    width: 100,
    customRender: (text) => receivableInvoiceStatusTxt[text] || '--',
    // scopedSlots: { customRender: "invoiceStatus" },
    ellipsis: true,
  },
  {
    title: '甲方开票主体',
    dataIndex: 'billingEntityA',
    key: 'billingEntityA',
    width: 100,
    customRender: (text) => text || '--',
    ellipsis: true,
  },
  {
    title: '乙方开票主体',
    dataIndex: 'billingEntityB',
    key: 'billingEntityB',
    width: 100,
    customRender: (text) => text || '--',
    ellipsis: true,
  },
  // {
  //   title: '开票主体',
  //   dataIndex: 'billingEntity',
  //   key: 'billingEntity',
  // },
  {
    title: '账单生成日期',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 140,
    scopedSlots: { customRender: "createTime" },
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
    width: 200,
    ellipsis: true,
  },
]
// 账单详情页table配置
export const detailsTableColumns = [
  {
    title: '订单号',
    dataIndex: 'refCode',
    key: 'refCode',
    scopedSlots: { customRender: "refCode" },
    width: 200,
    fixed: true,
  },
  {
    title: '外部单号',
    dataIndex: 'crmNumber',
    key: 'crmNumber',
    scopedSlots: { customRender: "crmNumber" },
    width: 180,
    ellipsis: true,
  },
  {
    title: '外部客户',
    dataIndex: 'outCustomerName',
    key: 'outCustomerName',
    scopedSlots: { customRender: "outCustomerName" },
    width: 180,
    ellipsis: true,
  },
  {
    title: '线路标识',
    dataIndex: 'lineName',
    key: 'lineName',
    scopedSlots: { customRender: "lineName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '收货门店',
    dataIndex: 'startStationName',
    key: 'startStationName',
    scopedSlots: { customRender: "startStationName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '门店详细地址',
    dataIndex: 'startAddress',
    key: 'startAddress',
    scopedSlots: { customRender: "startAddress" },
    width: 220,
    ellipsis: true,
  },
  {
    title: '要求取货时间',
    dataIndex: 'takeGoodsTime',
    key: 'takeGoodsTime',
    scopedSlots: { customRender: "takeGoodsTime" },
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    width: 180,
    ellipsis: true,
  },
  {
    title: '司机',
    dataIndex: 'driverName',
    key: 'driverName',
    width: 140,
    ellipsis: true,
    customRender: (text, row) => {
      const { shippingOrders = [] } = row.shippingOrders;
      console.log(shippingOrders, 'shippingOrders');
      return shippingOrders.length ? shippingOrders[0].driverName : '-'
    },
  },
  {
    title: '应付金额(元)',
    dataIndex: 'costValue',
    key: 'costValue',
    width: 140,
    ellipsis: true,
  },
  {
    title: '签收时间',
    dataIndex: 'signTime',
    key: 'signTime',
    scopedSlots: { customRender: "signTime" },
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    width: 180,
    ellipsis: true,
  },
  {
    title: '签收重量',
    dataIndex: 'signWeight',
    key: 'signWeight',
    width: 220,
    ellipsis: true,
  },
]

const adjustStatus = {
  AUDIT: '审核',
  NORMAL: '通过',
  REJECT: '驳回',
  CANCEL: '撤销',
}
// 账单调整记录table配置
export const billAdjustmentEntryTableColumns = [
  {
    title: '调整单据号',
    dataIndex: 'billCode',
    key: 'billCode',
    scopedSlots: { customRender: "billCode" },
    width: 180,
    fixed: true,
    ellipsis: true,
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    scopedSlots: { customRender: "projectName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '费用类型',
    dataIndex: 'costName',
    key: 'costName',
    scopedSlots: { customRender: "costName" },
    width: 180,
    ellipsis: true,
  },
  {
    title: '调整金额',
    dataIndex: 'moneyTaxFormat',
    key: 'moneyTaxFormat',
    scopedSlots: { customRender: "moneyTaxFormat" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    scopedSlots: { customRender: "remark" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '提交人',
    dataIndex: 'createUser',
    key: 'createUser',
    scopedSlots: { customRender: "createUser" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '调整时间',
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: "createTime" },
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    width: 180,
    ellipsis: true,
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    customRender: (text) => adjustStatus[text] || '-',
    width: 140,
    ellipsis: true,
  },
]

// 发票明细table配置
export const invoiceDetailTableColumns = [
  {
    title: '发票号码',
    dataIndex: 'invoiceNumber',
    key: 'invoiceNumber',
    scopedSlots: { customRender: "invoiceNumber" },
    width: 180,
    fixed: true,
    ellipsis: true,
  },
  {
    title: '发票代码',
    dataIndex: 'invoiceCode',
    key: 'invoiceCode',
    scopedSlots: { customRender: "invoiceCode" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '开票日期',
    dataIndex: 'invoiceTime',
    key: 'invoiceTime',
    scopedSlots: { customRender: "invoiceTime" },
    width: 180,
    ellipsis: true,
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-',
  },
  {
    title: '购买方（甲方）',
    dataIndex: 'partyAName',
    key: 'partyAName',
    scopedSlots: { customRender: "partyAName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '销售方（乙方）',
    dataIndex: 'partyBName',
    key: 'partyBName',
    scopedSlots: { customRender: "partyBName" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '开票金额',
    dataIndex: 'usePayableTaxQuota',
    key: 'usePayableTaxQuota',
    scopedSlots: { customRender: "usePayableTaxQuota" },
    width: 140,
    ellipsis: true,
  },
  {
    title: '发票文件',
    dataIndex: 'fileUrl',
    key: 'fileUrl',
    scopedSlots: { customRender: "fileUrl" },
    width: 140,
    ellipsis: true,
  },
]
// 费目明细table配置
export const costBreakdownColumns = [
  {
    title: '序号',
    key: 'index',
    dataIndex: 'index',
    scopedSlots: { customRender: "index" },
    width: 80,
  },
  {
    title: '费目名称',
    dataIndex: 'costCode',
    key: 'costCode',
  },
  {
    title: '应付金额(元)',
    dataIndex: 'billValue',
    key: 'billValue',
  },
]
// 账单列表页搜索栏配置
export const SearchFiled = [
  {
    label: '服务商',
    name: 'customerCode',
    type: 'carrier',
    prop: {
      isDefaultSelect: true
    }
  },
  {
    label: '对账单名称',
    name: 'billName',
    type: 'input',
    prop: {
      placeholder: '请输入账单名称',
      maxLength: 100
    },
  },
  {
    label: '账单批次号',
    name: 'billCode',
    type: 'input',
    prop: {
      placeholder: '请输入账单批次号',
      maxLength: 100
    },
  },
  // {
  //   label: '订单号',
  //   name: 'orderCode',
  //   type: 'input',
  //   prop: {
  //     placeholder: '请输入订单号',
  //     maxLength: 100
  //   },
  // },
  // {
  //   label:'子单号',
  //   name:'orderCode',
  //   type:'input',
  //   prop:{
  //     placeholder: '请输入子单号',
  //     maxLength:100
  //   },
  // },
  {
    label: '账期月份',
    name: 'accountMonth',
    type: 'month',
    prop: {
      placeholder: '请选择账单月份',
      allowClear: true,
      valueFormat: 'YYYY-MM'
    },
  },
  {
    label: '开票状态',
    name: 'invoiceStatus',
    type: 'select',
    prop: {
      placeholder: '请选择开票状态',
      allowClear: true,
      options: formatData(receivableInvoiceStatusTxt)
    },
  },
  // {
  //   label:'外部客户',
  //   name:'outCustomerName',
  //   type:'input',
  //   prop:{
  //     placeholder: '请输入外部客户',
  //     maxLength:100,
  //   },
  // },
  // {
  //   label:'开票主体',
  //   name:'billingEntity',
  //   type:'input',
  //   prop:{
  //     placeholder: '请输入开票主体',
  //     maxLength:100,
  //   },
  // },
  {
    label: '服务方名称',
    name: 'payee',
    type: 'input',
    prop: {
      placeholder: '请输入服务方名称',
      maxLength: 100,
    },
  },
  {
    label: '创建日期',
    name: 'createTime',
    type: 'date',
    prop: {
      showTime: {
        format: "HH:mm:ss",
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
        ],
      },
      allowClear: true,
      format: "YYYY-MM-DD HH:mm:ss",
      placeholder: ['开始日期', '结束日期'],
      maxLength: 100,
    },
  },
]
// 账单详情页搜索栏配置
export const detailsSearchFiled = [
  {
    label: '订单号',
    name: 'refCode',
    type: 'input',
    prop: {
      placeholder: '请输入订单号',
      maxLength: 100,
      allowClear: true,
    },
  },
  {
    label: '外部客户',
    name: 'outCustomerName',
    type: 'input',
    prop: {
      placeholder: '请输入外部客户名称',
      maxLength: 100,
      allowClear: true,
    }
  },
  {
    label: '线路标识',
    name: 'lineName',
    type: 'input',
    prop: {
      placeholder: '请输入线路标识',
      maxLength: 100,
      allowClear: true,
    }
  },
  {
    label: '收货门店',
    name: 'startStationName',
    type: 'input',
    prop: {
      placeholder: '请输入收货门店地址',
      maxLength: 100,
      allowClear: true,
    }
  }
]
